import classNames from "classnames"

export default function MandatoryIcon() {
  const iconClassNames = classNames(
    "bg-gray-600 text-white rounded text-xs h-4 w-4 content-center text-center"
  )

  return <div className={iconClassNames}>M</div>
}
